import SvgIcon from '@mui/material/SvgIcon';

export const CariadIcon = () => (
  <SvgIcon
    width="67"
    height="67"
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67 33.5C67 52.0015 52.0015 67 33.5 67C14.9985 67 0 52.0015 0 33.5C0 14.9985 14.9985 0 33.5 0C52.0015 0 67 14.9985 67 33.5Z"
      fill="#442EE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.1716 33L22.5858 16.4142L25.4142 13.5858L44.8284 33L25.4142 52.4142L22.5858 49.5858L39.1716 33Z"
      fill="#1EEF97"
    />
  </SvgIcon>
);
